import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="container mx-auto px-6 py-6 sm:px-8 md:px-12 lg:px-16 xl:px-60">
      <h1 className="text-5xl font-bold text-red-500">404 - Page Not Found</h1>
      <p className="mt-4">Oops! The page you are looking for does not exist.</p>
      <Link
        to="/"
        className="bg-primary text-white px-8 py-4 text-xl rounded-lg shadow-md transition-transform duration-300 ease-in-out  hover:font-bold"
      >
        Go Home
      </Link>
    </div>
  );
};

export default NotFound;
